import React, { useContext, useEffect, useState } from 'react';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { Card } from 'react-bootstrap';
import axios from "axios";
import { Unauthorized } from '../helpers/Unauthorized';
import { DatosPersonales } from './DatosPersonales';
import { ChangePassword } from './ChangePassword';
import { Historial } from './Historial';
import './Profile.css';
import { authContext } from '../Context/AuthContext';
import { FaUserCircle } from 'react-icons/fa';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import DNIList from '../shared/DNIList/DniList';
import UploadDNI from '../shared/UploadDNI/UploadDNI';
import PanelAdmin from './PanelAdmin';

const apiPedidos = process.env.REACT_APP_API_PEDIDOS;

export const Profile = () => {
    const { token, user } = useContext(authContext);
    const [compras, setCompras] = useState();
    const [userFull, setUserFull] = useState(null);
    const navigate = useNavigate()
    const country = process.env.REACT_APP_COUNTRY

    useEffect(() => {
        if (!user) return false;

        // Pedidos
        axios
            .get(`${apiPedidos}/ordenes/cliente/${user.Cliente}?Limit=${10}&Offset=${0}`, {
                headers: { Authorization: 'Bearer ' + token },
            })
            .then((res) => {
                if (res.status === 200) {
                    setCompras(res.data.pedidos);
                }
            })
            .catch((err) => {
                console.log(err);
                if (err.response && err.response.status === 500) {
                    toast.error('No se puede ver esta sección en estos momentos');
                    navigate('/');
                } else if (err.response && err.response.status === 404) {
                    toast.error('No se puede ver la informacion en estos momentos');
                } else if (err.response && err.response.status === 401) {
                    toast.error('Aun no hay compras a su nombre.');
                } else {
                    console.log(err);
                }
            });

        // Obtener usuario completo por email
        axios
            .get(`${process.env.REACT_APP_API_CLIENTE}/users`, {
                headers: { Authorization: 'Bearer ' + token },
            })
            .then((res) => {
                if (res.status === 200 && Array.isArray(res.data.users)) {
                    const found = res.data.users.find(u => u.Email === user.Email);
                    if (found) setUserFull(found);
                }
            })
            .catch((err) => {
                console.log('Error obteniendo usuario completo:', err);
            });
    }, []);


    if (!token) return <Unauthorized />;

    return (
        <>
                <div className="mb-4 w-100" style={{ position: 'relative', zIndex: 1 }}>
                    {/* Fade-in animation CSS */}
                    <style>{`
                        .fade-in-title {
                            opacity: 0;
                            animation: fadeInTitle 1.2s ease-out forwards;
                        }
                        @keyframes fadeInTitle {
                            from { opacity: 0; transform: translateY(20px); }
                            to { opacity: 1; transform: translateY(0); }
                        }
                    `}</style>
                    <div
                        className="d-flex align-items-center gap-3 flex-column flex-md-row shadow-sm rounded-4 p-4"
                        style={{
                            background: 'rgba(255,255,255,0.7)',
                            backdropFilter: 'blur(10px)',
                            WebkitBackdropFilter: 'blur(10px)',
                            border: '1px solid #e3e6ee',
                            boxShadow: '0 4px 24px rgba(30,60,120,0.08)',
                        }}
                    >
                        {/* Icono eliminado para diseño más limpio */}
                        <div className="flex-grow-1 text-center">
                            <h1 className="mb-1 text-dark fw-bold fade-in-title" style={{ fontSize: '2.8rem', letterSpacing: '0.01em', textAlign: 'center', lineHeight: 1.1 }}>
                                Panel de control
                                {userFull?.Administrador === true ? (
                                    <span className="ms-2 align-middle badge bg-primary text-white fw-semibold" style={{ fontSize: '1.1rem', verticalAlign: 'middle' }}>
                                        Admin
                                    </span>
                                ) : (
                                    <span className="ms-2 align-middle badge bg-secondary text-white fw-semibold" style={{ fontSize: '1.1rem', verticalAlign: 'middle' }}>
                                        Usuario
                                    </span>
                                )}
                            </h1>
                            <p className="text-muted mb-0" style={{ fontSize: '1.15rem', textAlign: 'center' }}>
                                Desde esta pantalla puede administrar su cuenta y ver información sobre sus pedidos
                            </p>
                        </div>
                    </div>
                </div>
            <Tabs
                defaultActiveKey="historial"
                id="fill-tab-example"
                className="mb-3"
                fill
            >
                <Tab eventKey="datos-personales" title="Datos personales">
                    <DatosPersonales user={user} />
                </Tab>
                <Tab eventKey="historial" title="Historial de compras">
                    <Historial compras={compras} />
                </Tab>
                <Tab eventKey="psw" title="Cambiar contraseña">
                    <ChangePassword />
                </Tab>

                {country === "ARG" && (
                    <Tab eventKey="dniadd" title="Cargar DNI">
                        <UploadDNI />
                    </Tab>
                )}

                {country === "ARG" && (
                    <Tab eventKey="dnilist" title="Listar DNI">
                        <DNIList />
                    </Tab>
                )}

                {userFull?.Administrador === true && (
                    <Tab eventKey="paneladmin" title="Gestion de usuarios">
                        <PanelAdmin />
                    </Tab>
                )}
            </Tabs>
        </>
    );
};
